/**
 * StreamStatusBadge — REMOVED per data integrity mandate.
 * No status/freshness labels allowed in the user UI.
 */

export const StreamStatusBadge = () => null;
export default StreamStatusBadge;
